import React from 'react';
import moment from 'moment';
import { Label, Input, Col, Row } from 'reactstrap';

const YearMonthPicker = (props) => {

    const value = (props && props.value) ? moment(props.value) : moment();

    const onChange = (year, month) => {
        let newDate = moment();
        newDate.set('year', year || value.year()).set('month', month || value.month());
        props.onChange(newDate.format('YYYY-MM'));
    };

    const getMonths = () => <Input type='select' value={value.month()} onChange={(e) => onChange(null, e.target.value)}>
        {moment.months().map((month, index) => <option value={index}>{month}</option>)}
    </Input>

    const getYears = () => {
        const options = [];

        for (let year = moment().year(); year > 1899; year--) {
            options.push(<option value={year}>{year}</option>);
        }

        return <Input type='select' value={value.year()} onChange={(e) => onChange(e.target.value, null)}>{options}</Input>
    };

    return (
        <Row>
            <Col>
                <Label>
                    Year:
                </Label>
                {getYears()}
            </Col>
            <Col>
                <Label>
                    Month:
                </Label>
                {getMonths()}
            </Col>
        </Row>
    );
};

export default YearMonthPicker;
